var render, staticRenderFns
import script from "./WidgetVulnerableComponents.vue?vue&type=script&lang=js&"
export * from "./WidgetVulnerableComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed309f7')) {
      api.createRecord('6ed309f7', component.options)
    } else {
      api.reload('6ed309f7', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/WidgetVulnerableComponents.vue"
export default component.exports